/**
 * Pick the curation id for an EMA product or procedural-step PUT.
 *
 * The backend looks the row up by a composite key that includes the curation id
 * from the URL. An existing QCD row must be written back to its own curation.
 * A new row, or a GET row with no curation id, is written to the page curation.
 * Changing the lookup key (pno / appl_no) is an add, so it also uses the page curation.
 */
export const resolveEmaPutCurationId = (
  currentCurationId: string,
  rowCurationId: string | null | undefined,
  lookupKeyUnchanged: boolean
): string => {
  if (lookupKeyUnchanged && rowCurationId) {
    return rowCurationId;
  }
  return currentCurationId;
};

export const toCurationId = (value: unknown): string | null => {
  if (!value) {
    return null;
  }
  const normalized = String(value).trim();
  if (!normalized || ['null', 'undefined'].includes(normalized)) {
    return null;
  }
  return normalized;
};
